module.exports = __webpack_public_path__ + "media/images/photo/hayama-an-8d5941e65dd2a0c5ff9867d5f53d8c85.png";